// agents/src/config/markets.js

export const MARKETS = {
  it: {
    code: 'it',
    name: 'Italia',
    language: 'it',
    nativeLanguage: 'it', // Idioma nativo del mercado
    apiUrl: process.env.REACT_APP_API_URL_IT || 'https://waserver.life5.it/api',
    socketUrl: process.env.REACT_APP_SOCKET_URL_IT || 'https://waserver.life5.it'
  },
  es: {
    code: 'es',
    name: 'España',
    language: 'es',
    nativeLanguage: 'es', // Idioma nativo del mercado
    apiUrl: process.env.REACT_APP_API_URL_ES || 'https://waserver.life5.es/api',
    socketUrl: process.env.REACT_APP_SOCKET_URL_ES || 'https://waserver.life5.es'
  }
};

// Available languages
export const AVAILABLE_LANGUAGES = [
  { code: 'en', name: 'English', icon: '<span class="fi fi-gb"></span>' },
  { code: 'it', name: 'Italiano', icon: '<span class="fi fi-it"></span>' },
  { code: 'es', name: 'Español', icon: '<span class="fi fi-es"></span>' }
];

// Get current market from environment or default to Italy
export const getCurrentMarket = () => {
  const marketCode = process.env.REACT_APP_MARKET || 'it';
  return MARKETS[marketCode] || MARKETS.it;
};

// Get API configuration
export const getApiConfig = () => {
  // For development, use env vars if set directly
  if (process.env.REACT_APP_API_URL && process.env.REACT_APP_SOCKET_URL) {
    return {
      apiUrl: process.env.REACT_APP_API_URL,
      socketUrl: process.env.REACT_APP_SOCKET_URL
    };
  }

  const market = getCurrentMarket();
  return {
    apiUrl: market.apiUrl,
    socketUrl: market.socketUrl
  };
};
